(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getHostAndMethod = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _exports.__esModule = true;
  _exports["default"] = getHostAndMethod;

  function getHostAndMethod(host, methodName) {
    if (!host) {
      return [null, null];
    }

    var methods = methodName.split(".");
    var context = host;
    var contextName = null;
    var m = null; // main.share.updateShareOptions
    // methodName = 'share.updateShareOptions'

    for (var i = 0; i < methods.length; i++) {
      contextName = methods[i];

      if (!(contextName in context)) {
        return [null, null];
      } // @ts-ignore


      m = context[contextName];

      if (i === methods.length - 1) {
        break;
      } else {
        context = m;
      }
    }

    return [context, contextName];
  }
});
//# sourceMappingURL=getHostAndMethod.js.map